import "./maintenance-page.css";

/** Shown app-wide instead of normal routes when REACT_APP_MAINTENANCE_MODE=true. */
const MaintenancePage = () => (
  <div className="dbm-maint">
    <div className="dbm-maint__card">
      <h1 className="dbm-maint__wordmark">
        db<span>m</span><span>.</span><span className="dbm-maint__chat">chat</span>
      </h1>
      <h2 className="dbm-maint__title">Down for maintenance<span className="dbm-maint__dot">.</span></h2>
      <p className="dbm-maint__sub">
        We're making some updates. Chat will be back shortly — no action needed on your end.
      </p>
    </div>
  </div>
);

export default MaintenancePage;
